import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import {Icon, LabelWithoutJson} from '@/components/atoms';

/**
 * AddressField component renders a box containing an icon and a label.
 *
 * @param {string} props.id - The id for the Box component.
 * @param {string} props.text - The text to be displayed in the label.
 * @returns {JSX.Element} The rendered AddressField component.
 */
const AddressField = ({id, text, isIconVisible = true}) => {
  return (
    <Box className={`flex items-center pb-4 pt-2`}>
      {isIconVisible && (
        <Icon
          className={'pr-3 text-white'}
          icon={'location_on'}
          size={'small'}
        />
      )}
      <LabelWithoutJson id={id} fontWeight={'font-bold'} text={text} />
    </Box>
  );
};

AddressField.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  isIconVisible: PropTypes.bool
};

export default React.memo(AddressField);
